import { useEffect } from 'react';
import { getUserManager } from '../config/keycloak';

// Loaded in a hidden iframe by oidc-client-ts (see silent_redirect_uri in
// config/keycloak.js) to complete a background token refresh without a full
// page navigation. Previously this route/file didn't exist at all, so every
// silent-renew attempt 404'd — automaticSilentRenew never actually worked,
// and the app fell back to a full interactive signinRedirect() (a real IdP
// round-trip) whenever the access token expired. That's the exact moment a
// broker-federated login (e.g. Google via Keycloak) can hand back a
// different `sub` for the same person, silently swapping discover_user_id.
export default function SilentRenew() {
  useEffect(() => {
    getUserManager()
      .signinSilentCallback()
      .catch((err) => {
        console.error('Silent renew failed:', err);
      });
  }, []);

  return null;
}
